import { defineStore } from 'pinia'

export interface Country {
  name: string
  alpha2: string
  dialingCode: number
  isTop: boolean
  hasPostCode: boolean
  order: number | null
}

export const useCountriesStore = defineStore('countries', () => {
  const countries = ref<Country[]>([])
  const lang = ref<string>('')

  onMounted(async () => {
    const langCode = (useRoute().params.lang as string) || 'en-gb'
    if (!countries.value.length || lang.value !== langCode) {
      lang.value = langCode
      const response = await $fetch(`/api/countries/${langCode}/`)

      if (!response.countries) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      countries.value = response.countries.map((country) => ({
        alpha2: country.alpha2,
        dialingCode: country.dialingCode,
        hasPostCode: country.hasPostCode,
        isTop: country.isTop,
        name: country.name,
        order: country.order,
      }))
    }
  })

  return { countries }
})
